<template>
    <v-dialog persistent v-model="get_dialogMain.dialog" width="800px" justify-center>
        <v-toolbar dense dark color="blue darken-2">
            <v-toolbar-title>
                <h3 v-if="get_dialogMain.type == 'create'">Nuevo Encuesta </h3>
                <h3 v-else>Editar Encuesta </h3>
            </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn icon dark @click="HIDDE_DIALOG_MAIN()">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-toolbar>
            <EncuestaForm :model="encuenta" :on-success="saveEncuesta" :on-cancel="cancel" />
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import EncuestaForm from '@/components/forms/EncuestaForm'
export default {
  data: () => ({
    encuenta: {
      preguntas: []
    }
  }),
  components: {
    EncuestaForm
  },
  methods: {
    ...mapActions(['getUrlServices', 'postUrlServicesAction']),
    saveEncuesta (model) {
      this.encuenta = model
      this.getUrl('survey.store')
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    getUrl (objet) {
      if (this.get_urls != null) {
        const router = this.get_urls[objet]
        this.postUrlServicesAction({ url: router, data: this.encuenta })
      } else {
        this.getUrlServices()
      }
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA_MAIN', 'SET_DATA_ENCUESTA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_urls () {
      this.getUrl('survey.store')
    },
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitos!',
        text: 'Se registro correctamente la encuesta'
      })
      this.SET_DATA_ENCUESTA(val)
      this.cancel()
    }
  },
  beforeDestroy () {
    this.CLEAR_DATA_MAIN()
  }
}
</script>

<style>

</style>
